import {useMutation} from '@apollo/react-hooks';

import type {
    DeleteSubdomain as DeleteSubdomainMutation,
    DeleteSubdomainVariables as DeleteSubdomainMutationVariables,
    SubdomainDeleteInput,
} from 'nutshell-graphql-types';

import DELETE_SUBDOMAIN from '../mutations/delete-subdomain.graphql';

export function useDeleteSubdomain(): {
    deleteSubdomain: (arg1: SubdomainDeleteInput) => Promise<any>;
    isDeleting: boolean;
} {
    const [deleteSubdomain, {loading}] = useMutation<
        DeleteSubdomainMutation,
        DeleteSubdomainMutationVariables
    >(DELETE_SUBDOMAIN);

    return {
        deleteSubdomain: (input: SubdomainDeleteInput) =>
            deleteSubdomain({
                variables: {subdomain: input},
            }),
        isDeleting: loading,
    };
}
